import UpgradeAccountInconsistentData from './UpgradeAccountInconsistentData';

export default UpgradeAccountInconsistentData;
